import cn from 'classnames';
import { Modal, ModalProps } from 'antd';
import bg from '../../assets/images/plus-bg.png';

interface Props extends ModalProps {
	children: JSX.Element | JSX.Element[];
}

export default function ModalWithImage({ children, ...props }: Props) {
	return (
		<Modal {...props} className={cn('p-relative', props.className)}>
			<img className='modalBgImage' src={bg} alt='background' />
			{children}
		</Modal>
	);
}
